// ignoring because we can't test vue-router 3
/* istanbul ignore file */

const RouteGuardMixin = {
  data() {
    return {
      RGUid: new Date().getTime() +  '',
      RGIndex: 0,
      unregisterRouterGuard: ()=>{},
    }
  },
  created() {
    this.RGInitOnStart && this.RGInit();
  },
  methods: {
    RGInit() {
      const currentRouteIndex = this.$route.query.RGIndex;
      this.RGIndex = currentRouteIndex ? currentRouteIndex + 1 : 1;
      this.$router.push({
        path: this.$route.path,
        params: this.$route.params,
        query: {...this.$route.query, RGUid: this.RGUid, RGIndex: this.RGIndex}
      });
      this.unregisterRouterGuard = this.$router.beforeEach(this.RGRouting);
    },
    RGRouting(to, from, next) {
      const exitingFromThisComponent = from.query.RGUid === this.RGUid;
      if (exitingFromThisComponent) {
        const toComponentWithoutThisMixin = Number.isNaN(parseInt(to.query.RGIndex));
        if(toComponentWithoutThisMixin) {
          this.RGCB();
        } else {
          const routToMixinBeforeThis = parseInt(to.query.RGIndex) < this.RGIndex;
          if(routToMixinBeforeThis) this.RGCB()
        }
      }
      next();
    },
    RGCB() {
      // RGCB = Route Guard Call Back
      if(this.routeGuardCb) {
        // you can set on the component data pointer to the method
        this.routeGuardCb()
      } else {
        // you can set on the parent component listener to this action
        this.$emit('onBrowserBackBtn');
      }
    }
  },
  destroyed() {
    this.unregisterRouterGuard();
    if (this.$route.query.RGUid === this.RGUid) {
      this.$router.go(-1);
    }
  }
}
export default RouteGuardMixin;
